import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';

import { config } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';

import { HelperService, HTTPService, CalculationService, FormatService, DateService, DataService, SocketService } from 'app/services';
import { SendStatementDialogComponent } from '../send-statement-dialog/send-statement-dialog.component';
import { CreateBulkPaymentDialogComponent } from '../create-bulk-payment-dialog/create-bulk-payment-dialog.component';
import { MovedInvoicesStatementDialogComponent } from '../moved-invoices-statement-dialog/moved-invoices-statement-dialog.component';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { currency } from 'app/constants/currency.constants';

import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { sortBy, sum } from 'lodash';

@Component({
  selector: 'app-statement-add-dialog',
  templateUrl: './create-statement-dialog.component.html',
  styleUrls: ['./create-statement-dialog.component.scss'],
  providers: [DialogService],
  encapsulation: ViewEncapsulation.None,
})
export class CreateStatementDialogComponent implements OnInit, OnDestroy {
  @ViewChild('dt') table: Table;
  statementId: string = '';
  customerId: string = '';
  companyId: string = '';
  dataMode: string = '';
  qboId: string = '';
  statement: any = {};
  defaultStatment: any = {};
  errors: any = {
    title: '',
  };
  focus: any = {
    name: true,
  };
  isProcessing: boolean = false;
  usd: string = currency.USD;
  statementList: any = [];
  activities: any = [];
  config = config;
  actions: any = [{ name: 'Edit statement', value: 'edit-statement' }];
  totalRecords: any;
  loading: boolean = true;
  estimates = [];
  disableQbo = true;
  duplicateEstimates = [];
  noRecFound: boolean = false;
  filterQuery: any = <any>{
    page: 1,
    limit: 1000,
    sortField: 'createdAt',
    sortOrder: -1,
    isArchived: false,
    orderStatus: 'invoice',
    paymentStatus: null,
    isUnpaid: false,
    isPaidPartial: false,
    isPaidFull: false,
    invoiceType: null,
    startDate: null,
    endDate: null,
    skip: 0,
    sort: 'order',
    order: 1,
  };
  isEstimateSelected: boolean = false;
  isLoading: boolean = false;
  openFrom: string = '';
  invoiceType: string = '';
  paymentStatus: any = [];
  statementActivityIcons = {
    added: 'fas fa-file-invoice',
    updated: 'fas fa-file-invoice',
    moved: 'fas fa-file-invoice',
  };
  headerOptions: any = {
    date: true,
    dateRang: true,
    statementStatus: false,
    paidStatus: true,
  };
  statementOptions: any[] = [
    { title: 'Download', value: 'download', icon: 'save' },
    { title: 'Print', value: 'print', icon: 'print' },
  ];
  cols: any[] = [
    {
      field: 'checkbox',
      header: '',
      isShowSortIcon: false,
      className: 'statement-checkbox',
    },
    {
      field: 'invCode',
      header: 'Invoice#',
      isShowSortIcon: false,
      className: 'invoice-date',
    },
    {
      field: 'vehicle',
      header: 'Vehicle',
      isShowSortIcon: false,
      className: 'vehicle',
    },
    {
      field: 'invoiceDate',
      header: 'Invoiced Date',
      isShowSortIcon: false,
      className: 'invoice-date',
    },
    {
      field: 'paymentStatus',
      header: 'Status',
      isShowSortIcon: false,
      className: 'payment-status',
    },
    {
      field: 'totalOrderAmount',
      header: 'Total value',
      isShowSortIcon: false,
      className: 'total-value',
    },
    {
      field: 'amountRemaning',
      header: 'Balance due',
      isShowSortIcon: false,
      className: 'amount-remaning',
    },
  ];
  isInvoiceLoading: boolean = false;
  isPrintingStatement: boolean = false;
  isDownloadingStatement: boolean = false;
  isSendingStatement: boolean = false;
  isSavingStatement: boolean = false;
  isPostingToQbo: boolean = false;
  showMultipleQBO: boolean = false;
  selectedInvoices: any = {};
  qboSocketResponse: any = {};
  statementTotal = {
    total: 0,
    paid: 0,
    due: 0,
    count: 0,
  };
  statementRange: any = {
    start: '',
    end: '',
  };
  tableCheckState: number = 0;
  isEditMode: boolean = true;
  currentInvoices: any[] = [];
  preAppliedFilters: any = null;
  socketListener: Subject<boolean> = new Subject<boolean>();
  dataListener: Subscription;
  isLostContext: boolean = true;
  isStatementZipFileEnabled: boolean = false;
  isLockOrderEnabled: boolean = false;
  isDirty = false;
  editModeLoaded = false;
  customerName: string = '';
  hasAccountStatement: boolean = false;
  isRevenueRecognitionSettleEnabled: boolean = false;
  isOpenFromBulk: boolean = false;
  unappliedAmount: number = 0;
  isCustomerPaymentEnabled: boolean = false;

  constructor(
    private helperService: HelperService,
    private httpService: HTTPService,
    public calculationService: CalculationService,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dialogService: DialogService,
    private formatService: FormatService,
    private dateService: DateService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private socketService: SocketService
  ) { }

  ngOnInit() {
    const { customerId, statementId, dataMode, customerName, isOpenFromBulk, invoices, name } = this.dynamicDialogConfig.data;
    const { companyId, qboId, isRevenueRecognitionSettleEnabled } = this.helperService.getCompany();
    this.isRevenueRecognitionSettleEnabled = isRevenueRecognitionSettleEnabled;
    this.customerId = customerId;
    this.statementId = statementId;
    this.companyId = companyId;
    this.qboId = qboId;
    this.dataMode = dataMode;
    this.customerName = customerName;

    if (isOpenFromBulk) {
      this.statement.name = name;
      this.statement.invoices = invoices;
      this.currentInvoices = invoices;
      this.isOpenFromBulk = true;
      this.setBulkStatmentInvoiceData();
      this.dataMode = 'edit';
      return;
    }
    if (this.statementId) {
      this.getStatementById();

      this.socketService
        .socketOn(`statement-zip-${this.statementId}`)
        .pipe(takeUntil(this.socketListener))
        .subscribe((data) => {
          this.isDownloadingStatement = false;
        });
    }
    this.setDataService();
  }

  openStatementFromAccount() {
    if (this.dataMode === 'openFromAccounts') {
      this.hasAccountStatement = true;
      this.tableCheckState = 1;
      this.estimates.forEach((data) => (this.selectedInvoices[data._id] = data));
      this.calculateStatementTotal(true);
    }
  }

  viewModeDate() {
    if (this.statement.filters && this.statement.filters.date && this.editModeLoaded) {
      let date: any = new Date(`${this.statement.filters.date.startDate}T00:00:00`);
      let lastDate: any = new Date(`${this.statement.filters.date.endDate}T00:00:00`);
      if (date === lastDate) {
        return `${this.dateService.formatDate(date, datetimeFormat.mmmmdyyyy)}`;
      }
      return `${this.dateService.formatDate(date, datetimeFormat.mmmmdyyyy)} - ${this.dateService.formatDate(lastDate, datetimeFormat.mmmmdyyyy)}`;
    }
  }

  editModeStatement() {
    if (this.dataMode === 'edit') return true;
    else return false;
  }

  ngOnDestroy() {
    if (this.socketListener) {
      this.socketListener.next(true);
      this.socketListener.unsubscribe();
    }

    if (this.dataListener) {
      this.dataListener.unsubscribe();
    }
  }

  setDataService() {
    this.dataListener = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'company-appdata-updated') {
          this.isStatementZipFileEnabled = this.dataService.isStatementZipFileEnabled;
          this.isLockOrderEnabled = this.dataService.isLockOrderEnabled;
          this.dataListener.unsubscribe();
        }
        if (data.key === 'multi-qbo-response') {
          this.qboSocketResponse = data.data;
          this.changeInvoiceSyncOrFail(this.qboSocketResponse);
          if (data.data.isComplete) this.isPostingToQbo = false;
        }
        if (data.key === 'statement-list-refresh') {
          this.getStatementById();
          this.getAllOrderList();
        }
      }
    });

    this.isStatementZipFileEnabled = this.dataService.isStatementZipFileEnabled;
    this.isLockOrderEnabled = this.dataService.isLockOrderEnabled;

    this.showMultipleQBO = this.qboId && this.statementId ? true : false;
    if (this.showMultipleQBO) {
      if (this.cols.some((e) => ['isSync'].includes(e.field))) {
        return;
      }
      this.cols.push({
        field: 'isSync',
        header: 'Sync status',
        isShowSortIcon: false,
        className: 'qbo-status',
      });
    }

    if (this.isRevenueRecognitionSettleEnabled) {
      this.cols.map((col) => {
        if (col.field === 'invoiceDate') {
          col.field = 'finalizeDate';
          col.header = 'Finalized Date';
        }
      })
    }
  }

  async getStatementById() {
    if (this.isOpenFromBulk) return;
    this.httpService.getStatementById(this.statementId, false, true, true, true).then(
      (res: any) => {
        if (res.statement && res.statement._id) {
          this.isDownloadingStatement = res.statement.isZipCreating;
          this.statement = res.statement;
          this.defaultStatment = this.helperService.deepCopy(this.statement);
          this.setStatementData();
        }
        if (res.logs && res.logs.length) {
          res.logs.forEach((log: any) => {
            log.createdAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(log.createdAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
          });
          this.activities = res.logs;
        }
        this.populateCurrentInvoice();
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );

    if (this.dataService.isCustomerPaymentEnabled) {
      try {
        const unappliedAmount = (await this.httpService.getCustomerPayments(this.customerId, { resultType: 'total' })) as number;
        this.unappliedAmount = unappliedAmount;
        this.isCustomerPaymentEnabled = true;
      } catch (err) {
        console.log(err);
      }
    }
  }

  setStatementData() {
    if (this.statement.filters) {
      this.isInvoiceLoading = true;
      this.statement.filters.paidStatus = { unPaid: false, partiallyPaid: false, paid: false };
      this.preAppliedFilters = this.helperService.deepCopy(this.statement.filters);
      this.filterChange(this.preAppliedFilters, { forceLoad: true });
    }
    if (this.statement && this.statement._id) {
      this.statementList = [];
      this.statement.invoices.forEach((invoice: any) => {
        invoice.paid = sum([
          this.calculationService.roundOff(invoice.card),
          this.calculationService.roundOff(invoice.cheque),
          this.calculationService.roundOff(invoice.cash),
          this.calculationService.roundOff(invoice.creditPayment),
          this.calculationService.roundOff(invoice.thirdParty),
        ]);
        invoice.amountRemaning = invoice.total.grand - invoice.paid;
        invoice.totalOrderAmount = invoice.total.grand;
        this.statementList.push(invoice._id);
        this.selectedInvoices[invoice._id] = invoice;
      });
      this.currentInvoices = this.statement.invoices;
      this.calculateStatementTotal();
    }
    if (this.statementList.length > 0) this.disableQbo = false;
  }

  setBulkStatmentInvoiceData() {
    // this.filterChange({}, true);
    this.statementList = [];
    this.statement.invoices.forEach((invoice: any) => {
      console.log(invoice);
      invoice.paymentStatus = invoice.isPaidFull ? 'Paid' : invoice.isPaidPartial ? 'Partial paid' : 'Unpaid';
      invoice.amountRemaning = invoice.unpaid;
      invoice.totalOrderAmount = invoice.total;
      this.statementList.push(invoice.invoiceId);
      this.selectedInvoices[invoice.invoiceId] = invoice;
    });
    this.currentInvoices = this.statement.invoices;
    this.calculateStatementTotal();
    if (!this.statementTotal?.paid) {
      this.statementTotal.paid = this.statementTotal.total - this.statementTotal.due;
    }
  }

  getAllOrderList() {
    this.filterQuery = {
      customerId: this.customerId,
      orderStatus: 'invoice',
      startDate: this.filterQuery.startDate,
      endDate: this.filterQuery.endDate,
      populateVehicle: true,
      isPaidPartial: this.filterQuery.partiallyPaid,
      isUnpaid: this.filterQuery.unPaid,
      isPaid: this.filterQuery.paid,
      limit: 1000,
    };

    if (this.statementId) {
      this.filterQuery.statementId = this.statementId;
    }

    this.statementRange.start = new Date(`${this.filterQuery.startDate} 00:00`);
    this.statementRange.end = new Date(`${this.filterQuery.endDate} 00:00`);

    this.isInvoiceLoading = true;
    this.httpService
      .getStatementInvoicesList(this.filterQuery)
      .then(
        (estimates) => {
          if (estimates.length > 0) {
            const startDateMilliSecond = new Date(`${this.filterQuery.startDate} 00:00`).getTime();
            const endDateMilliSecond = new Date(`${this.filterQuery.endDate} 23:59`).getTime();
            this.totalRecords = estimates.length;
            this.estimates = this.formatService.statementInvoiceList(estimates, {
              startDateMilliSecond,
              endDateMilliSecond,
            });
            // We need all statements even if they are bulk payment statements
            // .filter(({ lockedInvoiceWithStatement, statementId }) => !lockedInvoiceWithStatement || (lockedInvoiceWithStatement && statementId === this.statementId));
            this.noRecFound = this.estimates.length === 0 ? true : false;
            this.estimates.forEach((estimate: any) => {
              if (estimate.restriction) {
                const { status, token } = estimate.restriction;
                estimate.isRestricted = status === 'restricted';
              } else {
                estimate.isRestricted = false;
              }
            });
          } else {
            this.noRecFound = true;
            this.totalRecords = 0;
            this.estimates = [];
          }
          this.editModeLoaded = true;
          this.populateCurrentInvoice();
          this.calculateStatementTotal();
        },
        (error) => {
          this.helperService.showToaster('error', error);
        }
      )
      .finally(() => {
        this.isInvoiceLoading = false;
      });
  }

  populateCurrentInvoice() {
    if (this.statement._id && this.estimates.length > 0) {
      this.currentInvoices = [];
      this.estimates.forEach((invoice: any) => {
        if (this.selectedInvoices[invoice._id]) {
          this.currentInvoices.push(invoice);
        }
      });
    }
  }

  closeDialog() {
    if (!this.editModeStatement() && this.isDirty) {
      this.handleDiscardChanges();
    } else {
      if (this.statementId && this.isEditMode) {
        this.statement = this.helperService.deepCopy(this.defaultStatment);
        this.setStatementData();
      }
      this.dataService.showQboModel = true;
      this.dynamicDialogRef.close();
    }
  }

  handleDiscardChanges(discardChanges?) {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Discard changes to statement`,
        message: `There may be unsaved changes in this statement
         would you like to continue without saving?`,
        button: {
          success: { title: 'Yes, discard changes' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        if (discardChanges) {
          this.backToPreviousViewMode();
        } else {
          this.dataService.showQboModel = true;
          this.dynamicDialogRef.close();
        }
      }
      onClose.unsubscribe();
    });
  }

  handleAction({ value }) {
    if (value === 'edit-statement') {
      this.isEditMode = true;
      this.selectedInvoices;
    }
  }

  filterChange(filter?: any, options: any = {}) {
    if (this.statementId && !this.editModeLoaded && !options.forceLoad) {
      return;
    }

    // This is to avoid making get invoices call with default date range, it will call it once the statement is fetched
    if (this.statementId && !this.statement._id) return;

    // Check if date dropdown is dirty or touched
    if (options.isDirty && (this.totalRecords === 0 || this.totalRecords > 0)) {
      this.isDirty = true;
    }

    this.preAppliedFilters = filter;

    if (filter.date.startDate && filter.date.endDate) {
      this.filterQuery.startDate = filter.date.startDate;
      this.filterQuery.endDate = filter.date.endDate;

      if (filter.paidStatus) {
        this.filterQuery.partiallyPaid = filter.paidStatus.partiallyPaid;
        this.filterQuery.unPaid = filter.paidStatus.unPaid;
        this.filterQuery.paid = filter.paidStatus.paid;
      }

      this.getAllOrderList();
    }
  }

  onEdit() {
    this.openStatementModal('');
  }

  onSubmit(isForced: boolean = false) {
    if (!this.statement.name) {
      this.errors.name = '* Statement name is required';
      this.helperService.showToaster('error', 'Statement name is required');
      return;
    }
    if (!Object.keys(this.selectedInvoices).length) {
      this.helperService.showToaster('error', 'Please select at least 1 invoice');
      return;
    }

    let statementObj = {
      name: this.statement && this.statement.name,
      invoices: Object.keys(this.selectedInvoices),
      customerId: this.customerId,
      isForcedMoveInvoice: isForced,
      startDate: `${this.filterQuery.startDate} 00:00`,
      endDate: `${this.filterQuery.endDate} 23:59`,
      filters: this.preAppliedFilters,
    };

    if (!this.statementId) {
      this.createStatement(statementObj);
    } else {
      this.updateStatment(statementObj);
    }
  }

  createStatement(statementObj: any) {
    if (this.isSavingStatement) return;

    this.isSavingStatement = true;
    this.httpService
      .createStatement(statementObj)
      .then(
        (res: any) => {
          if (res && res.showMoveInvoiceConfirmation && res.movedInvoices) {
            this.openMoveInvoicesDialog(res.movedInvoices);
          } else {
            this.helperService.showToaster('success', 'Statement created');
            // this.dynamicDialogRef.close();
            this.backToPreviousViewMode(false, res._id);
            this.dataService.sendData(this.dataService.typePassData('statement-list', {}));
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isSavingStatement = false;
        // this.backToPreviousViewMode();
      });
  }

  updateStatment(statementObj: any) {
    if (this.isSavingStatement) return;

    this.isSavingStatement = true;
    this.httpService
      .updateStatementById(this.statementId, statementObj)
      .then(
        (res: any) => {
          if (res && res.showMoveInvoiceConfirmation && res.movedInvoices) {
            this.openMoveInvoicesDialog(res.movedInvoices);
          } else {
            this.helperService.showToaster('success', 'Statement updated');
            this.backToPreviousViewMode();
            // this.dynamicDialogRef.close();
            this.dataService.sendData(this.dataService.typePassData('statement-list', {}));
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isSavingStatement = false;
      });
  }

  backToPreviousViewMode(discardChanges?, statementId?) {
    if (discardChanges && this.isDirty) {
      this.handleDiscardChanges(discardChanges);
    } else {
      this.statementId = statementId ? statementId : this.statementId;
      this.openStatementModal('edit');
    }
  }

  openStatementModal(dataMode) {
    this.isDirty = false;
    this.dataMode = dataMode;
    this.selectedInvoices = {};
    this.getStatementById();
    this.setDataService();
  }

  openMoveInvoicesDialog(invoices: any[]) {
    const ref = this.dialogService.open(MovedInvoicesStatementDialogComponent, {
      styleClass: 'add-dialog small-heading-dialog export-report-dialog',
      showHeader: false,
      data: invoices,
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, moveInvoices }) => {
      if (isSuccess) {
        if (!moveInvoices) {
          invoices.forEach(({ invoiceId }) => {
            delete this.selectedInvoices[invoiceId];
          });
          this.calculateStatementTotal();
        }
        this.onSubmit(true);
        this.statement._id ? this.backToPreviousViewMode() : this.dynamicDialogRef.close();
      }

      onClose.unsubscribe();
    });
  }

  openCreateBulkPaymentDialog() {
    this.dialogService.open(CreateBulkPaymentDialogComponent, {
      width: '1000px',
      styleClass: 'add-dialog create-bulk-payment',
      showHeader: false,
      data: { statementId: this.statementId, customerId: this.customerId },
    });
  }

  /** Setting the focused inputs */
  focusInput(type: string) {
    this.focus[type] = true;
    this.errors[type] = '';
  }

  /** Removeing the errors from the fields */
  blurInput(type: string) {
    this.focus[type] = false;
  }

  /** Getting values from the inputs */
  handleChange(name: string, value: string) {
    this.isDirty = true;
    this.statement[name] = value;
  }

  handleStatementSelect(data: any, isChecked: boolean) {
    this.isDirty = true;
    if (isChecked) {
      this.selectedInvoices[data._id] = data;
    } else {
      delete this.selectedInvoices[data._id];
    }

    this.calculateStatementTotal();
  }

  handleAllInvoiceSelect(checkState: number) {
    this.isDirty = true;
    this.estimates.forEach((data) => {
      if (checkState === 0 || checkState === 2) {
        this.selectedInvoices[data._id] = data;
      } else if (checkState === 1) {
        delete this.selectedInvoices[data._id];
      }
    });

    this.calculateStatementTotal();
  }

  calculateStatementTotal(isOpenFormAR?) {
    this.statementTotal = {

      count: 0,
      total: 0,
      paid: 0,
      due: 0,
    };

    const sortedOrder: any = sortBy(Object.values(this.selectedInvoices), 'invoiceDate');

    sortedOrder.forEach((order: any) => {
      this.statementTotal.total += order.totalOrderAmount;
      this.statementTotal.due += order.amountRemaning;
      this.statementTotal.paid += order.paid;
      this.statementTotal.count++;
    });

    const selectedInvoiceCount = Object.keys(this.selectedInvoices).length;

    if (selectedInvoiceCount === 0) {
      this.tableCheckState = 0;
    } else if (selectedInvoiceCount === this.estimates.length) {
      this.tableCheckState = 1;
    } else {
      this.tableCheckState = 0;
    }

    if (!isOpenFormAR) {
      this.cdr.detectChanges();
    }
  }

  openSendStatementDialog() {
    this.isSendingStatement = true;
    const ref = this.dialogService.open(SendStatementDialogComponent, {
      width: '900px',
      styleClass: 'add-dialog',
      showHeader: false,
      data: {
        statementId: this.statementId,
        createAt: this.statement.createdAt,
        customerId: this.customerId,
      },
    });

    const onClose = ref.onClose.subscribe(() => {
      this.isSendingStatement = false;

      onClose.unsubscribe();
    });
  }

  handlePrint() {
    if (this.isPrintingStatement) return;

    this.isPrintingStatement = true;
    this.httpService
      .generateStatementPdfLink(this.companyId, this.statementId)
      .then(
        (data) => {
          if (data) {
            this.showFile(data);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isPrintingStatement = false;
      });
  }

  downloadFile(data: any) {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  handleZipDownload() {
    try {
      localStorage.setItem(`statement-${this.statementId}`, 'false');
    } catch (err) {
      console.log(err);
    }

    if (this.isDownloadingStatement) return;
    this.isDownloadingStatement = true;
    this.isLostContext = false;
    this.httpService
      .downloadStatementZip(this.statementId)
      .then(
        (url) => {
          if (url) {
            // window.open(url);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        // this.isDownloadingStatement = false;
      });
  }

  showFile(base64: any) {
    // decode base64 string, remove space for IE compatibility
    var binary = atob(base64.replace(/\s/g, ''));
    var len = binary.length;
    var buffer = new ArrayBuffer(len);
    var view = new Uint8Array(buffer);
    for (var i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
    }

    // create the blob object with content-type "application/pdf"
    var blob = new Blob([view], { type: 'application/pdf' });
    var url = URL.createObjectURL(blob);
    var myWindow = window.open(url, '_blank');
    myWindow.focus();
    myWindow.print();
  }

  openInvoice(invoiceId: string) {
    if (!invoiceId) return;

    this.helperService.openPageInNewExistingTab(`/estimate/${invoiceId}`, invoiceId);
  }

  postToQbo(reTryInvoice?, tryAgain = false) {
    if (this.isPostingToQbo) return;

    this.isPostingToQbo = true;
    const payload = {
      invoices: [],
      customerId: this.customerId,
      statementName: this.statement.name,
      statementId: this.statement._id,
    };

    if (tryAgain) {
      this.changeInvoiceToPending(reTryInvoice);
      payload.invoices = reTryInvoice;
    } else {
      this.changeInvoiceToPending(this.statementList);
      payload.invoices = this.statementList;
    }

    this.httpService
      .postMultipleInvoiceToQbo(this.companyId, payload)
      .then(
        (data) => {
          if (data) {
            // window.open(url);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        // this.isPostingToQbo = false;
      });
  }

  changeInvoiceToPending(invoiceArray) {
    invoiceArray.forEach((id) => {
      const estimateIndex = this.estimates.findIndex((val) => val._id === id);
      this.estimates[estimateIndex].isSync = 'Syncing';
    });
    return;
  }

  changeInvoiceSyncOrFail(data) {
    if (data && data.isComplete) return;
    if (data && data.invoiceId) {
      const estimateIndex = this.estimates.findIndex((val) => val._id === data.invoiceId);
      data.isFailed ? (this.estimates[estimateIndex].isSync = 'Failed - try again') : (this.estimates[estimateIndex].isSync = 'Synced');
      return;
    }
    return;
  }

  tryPostingAgain(data, status) {
    if (status != 'Synced') this.postToQbo([data], true);
    return;
  }

  isStateRestricted() {
    if (!this.isLockOrderEnabled) return false;

    const invoices = this.editModeStatement() ? this.currentInvoices : this.estimates;

    for (let i = 0; i < invoices.length; i++) {
      const { isRestricted } = invoices[i];

      if (isRestricted) return true;
    }

    return false;
  }
}
